export default __webpack_public_path__ + "static/MarcosPizza-76f98daf7d452431d20ceb23a6ee7f0d.png";